import { Box, Button, Container, Grid, Typography } from "@material-ui/core";

import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import useBackButtonRedirect from "../hooks/useBackButton";
import SectionHeader from "../components/SectionHeader";

export default function PasswordResetComplete() {
  useBackButtonRedirect();
  useEffect(() => {
    document.title = "パスワード変更完了画面 | じぶん専用IT相談室";
  }, []);
  const passwordReqList = [
    {
      name: "メールアドレス入力",
      color: "grey",
    },
    {
      name: "認証コードを送信しました",
      color: "grey",
    },
    {
      name: "メールのご確認",
      color: "grey",
    },
    {
      name: "メールのご確認",
      color: "grey",
    },
    {
      name: "パスワード変更完了",
      color: "primary",
    },
  ];
  return (
    <Fragment>
      <Box className="section bg-dots" component={"section"}>
        <Container>
          <Box sx={{ textAlign: "center" }}>
            <SectionHeader
              currentPage={"パスワードの変更が完了いたしました。"}
              preHeading={"Successfull"}
            />
            <Typography className="text-center">
              ログイン画面に移動して、新しいパスワードを入力して、ログインください。
            </Typography>
            <Box className="registeration-list-wrapper element-box">
              {passwordReqList.map((list, idx) => (
                <Grid container spacing={2} alignItems="center" key={idx}>
                  <Grid item>
                    <span className={`number-circle ${list.color}`}>
                      {idx + 1}
                    </span>
                  </Grid>
                  <Grid item>
                    <Typography
                      className={`color-${list.color} password-complete-text`}
                      component={"p"}
                    >
                      {list.name}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Box>
        </Container>
        <Box
          style={{ width: "300px", margin: "40px auto 0", maxWidth: "100%" }}
        >
          <Link to="/login">
            <button className="classification-btn" style={{ width: "100%" }}>
              ログイン画面へ
            </button>
          </Link>
        </Box>
      </Box>
    </Fragment>
  );
}
